<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <h2 class="dark--text font-weight-bold">Setmenu - Customers</h2>
      </v-flex>
    </v-layout>
    <v-container class="mt-5">
      <v-data-table :mobile-breakpoint="0" :headers="headers" :items="itemsWithSno" class="elevation-1" :loading="loading" :footer-props="{ 'items-per-page-options': [25, 50, 100, 500] }">
        <template v-slot:[`item.createdAt`]="{ item }"> {{ dateFormat(new Date(parseInt(item.createdAt))) }}</template>
        <template v-slot:[`item.customerName`]="{ item }">
          {{ item.customer && item.customer.user ? item.customer.user.firstnameEn : "" }}
          {{ item.customer && item.customer.user ? item.customer.user.lastnameEn : "" }}
        </template>
      </v-data-table>
    </v-container>
  </v-container>
</template>

<script>
import moment from "moment";
export default {
  components: {},
  watch: {
    "$route.query.masterId": {
      handler() {
        console.log("this.$route.query.masterId", this.$route.query.masterId);
        this.getSetMenuOrderDeliveriesByMasterId();
      },
    },
  },

  methods: {
    dateFormat(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    getSetMenuOrderDeliveriesByMasterId() {
      this.loading = true;
      this.$apollo
        .watchQuery({
          query: require("../api/getSetMenuOrderDeliveriesByMasterId.graphql"),
          variables: {
            masterId: this.$route.query.masterId,
          },
        })
        .refetch({
          variables: {
            masterId: this.$route.query.masterId,
          },
        })
        .then(data => {
          this.loading = false;
          if (data.data.getSetMenuOrderDeliveriesByMasterId) {
            this.orderDeliveryDetails = data.data.getSetMenuOrderDeliveriesByMasterId.setMenuOrderDeliveries;
          }
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
  },

  data: () => ({
    loading: true,
    btnloading: false,
    orderDeliveryDetails: [],
    headers: [
      {
        text: "#",
        value: "slNo",
        sortable: false,
        width: 60,
      },
      { text: "Order Id", value: "order_id", width: 50, sortable: false },
      {
        text: "Order Number",
        value: "orderNumber",
        width: 150,
        sortable: false,
      },
      {
        text: "Phone",
        value: "customer.user.phone",
        sortable: false,
        width: 120,
      },
      {
        text: "Customer",
        value: "customerName",
        sortable: false,
        width: 160,
      },
      {
        text: "Package Code",
        value: "package_code",
        sortable: false,
        width: 160,
      },

      {
        text: "Created Date",
        value: "createdAt",
        sortable: false,
        width: 120,
      },
    ],
  }),
  computed: {
    itemsWithSno() {
      if (this.orderDeliveryDetails == null) return [];
      return this.orderDeliveryDetails.map((d, index) => ({ ...d, slNo: index + 1 }));
    },
  },
  created() {},
  mounted() {
    this.getSetMenuOrderDeliveriesByMasterId();
  },
};
</script>
